module.exports = __webpack_public_path__ + "static/section3_background-732fd8a89eae6e5e48113d79b33d8b08.png";